import { IApplicationState } from '../../types/redux';

export function selectIsAuthenticated(state: IApplicationState): boolean {
  return state.user.isAuthenticated;
}
